// X165 (R76 S1): the second half of the breadcrumb rule (utils/adminBreadcrumbTrail). The route middleware marks that a
// new admin page owes its own trail; the page pays it with setAdminBreadcrumbs during its setup. Once the page has
// finished rendering (Nuxt's page:finish, after its async setup and mount) a trail still owed means the page set none,
// so the previous page's crumbs are cleared then, and not a moment earlier: the bar never blanks while the old page
// is still on screen. Client only: on the server every admin page sets its trail before the bar renders (X135).
import {onPageFinish} from '~/utils/adminBreadcrumbTrail';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', () => {
    const crumbs = useState('adminBreadcrumbs', () => []);
    const pending = useState('adminBreadcrumbsPending', () => false);
    const next = onPageFinish({crumbs: crumbs.value, pending: pending.value});
    if (next.crumbs !== crumbs.value) crumbs.value = next.crumbs;
    pending.value = next.pending;
  });
});
